import {
  IconCalendar,
  IconChevronLeft,
  IconClock,
  IconFlag,
  IconLogout,
  IconMail,
  IconMapPin,
  IconMapPlus,
  IconSettings,
  IconSmartHome,
  IconUsersGroup,
} from '@tabler/icons-angular';

export const tablerIcons = {
  IconCalendar,
  IconChevronLeft,
  IconClock,
  IconFlag,
  IconLogout,
  IconMail,
  IconMapPin,
  IconMapPlus,
  IconSettings,
  IconSmartHome,
  IconUsersGroup,
};
